(function () {
    var jq = jQuery;

    // Initialize social sliders
    jq('.js_social_slider_slider').each(function () {
        var slider = this;
        var sliderWrapEl = jq(slider).closest('.social-slider-sec');

        var swiperPagination = sliderWrapEl.find('.swiper-pagination')[0];
        var swiperButtonNext = sliderWrapEl.find('.swiper-button-next')[0];
        var swiperButtonPrev = sliderWrapEl.find('.swiper-button-prev')[0];

        const realSlides = jq(slider).find('.swiper-slide').length;

        new Swiper(slider, {
            spaceBetween: 40,
            slidesPerView: 1,
            centeredSlides: true,
            noSwipingClass: 'slide-card__action-link',
            watchSlidesProgress: true,
            loop: true,
            breakpoints: {
                768: {
                    slidesPerView: realSlides >= 2 ? 2 : 1,
                    centeredSlides: true,
                    loop: true,
                    spaceBetween: 40
                },
                992: {
                    slidesPerView: realSlides <= 2 ? 1 : 3.4,
                    centeredSlides: true,
                    loop: true,
                    spaceBetween: 40,
                    slideToClickedSlide: true,
                    paginationClickable: true
                }
            },
            pagination: {
                el: swiperPagination,
                clickable: true,
                dynamicBullets: false
            },
            navigation: {
                nextEl: swiperButtonNext,
                prevEl: swiperButtonPrev
            },
        });
    });


    // Social modal handling
    var modal = jq('#socialModal');
    var modalClose = modal.find('.js-modal-close');
    var leaveSiteBtn = jq('#leaveSiteBtn');
    var lastFocusedElement = null;

    function trapFocus(event) {
        var focusableNodes = modal.find('a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])');
        var first = focusableNodes[0];
        var last = focusableNodes[focusableNodes.length - 1];

        if (event.key === 'Tab') {
            if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        }
    }

    function openModal(trigger, url) {
        lastFocusedElement = trigger;

        modal.addClass('active-social-modal').css('display', 'flex');
        leaveSiteBtn.attr('href', url);
        jq('body').addClass('modal-open');

        // Move focus inside modal
        modalClose.focus();

        jq(document).on('keydown.trapFocus', trapFocus);

        // ESC to close
        jq(document).one('keydown.esc', function (e) {
            if (e.key === 'Escape') closeModal();
        });
    }

    function closeModal() {
        modal.removeClass('active-social-modal').css('display', 'none');
        jq('body').removeClass('modal-open');
        jq(document).off('keydown.trapFocus');

        if (lastFocusedElement) lastFocusedElement.focus();
    }

    // Open modal when clicking social slide
    jq('.js-open-social-modal').on('click', function (e) {
        e.preventDefault();
        var url = jq(this).data('external-url');
        openModal(this, url);
    });

    modalClose.on('click', closeModal);

})();
